import { createApi } from '@reduxjs/toolkit/query/react'

import StorageKeys from 'src/core/classes/cache/StorageKeys'
import { ILocale } from 'src/core/classes/models/ILocale'

import { getProcedureUrl } from './helpers/getBaseUrl'
import { getCustomQuery } from './helpers/getCustomQuery'
import { getResponseHandler } from './helpers/getResponseHandler'

export const referenceLocalesApi = createApi({
  reducerPath: '@app/api/referenceLocales',
  baseQuery: getCustomQuery({
    storageKey: StorageKeys.locales,
    baseUrl: getProcedureUrl('spApp_getLocales'),
  }),
  endpoints: (builder) => ({
    getReferenceLocales: builder.query<ILocale[], void>({
      query: () => {
        return {
          url: ``,
          method: 'POST',
          responseHandler: getResponseHandler({
            storageKey: StorageKeys.locales,
          }),
        }
      },
    }),
  }),
})

export const { useGetReferenceLocalesQuery } = referenceLocalesApi
